import { httpClient } from '@/network/clientController'

/** Get List of notifications preferences
@docs Não existe
*/
export const getNotificationsPreferencesList = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'notification/preference',
		isCancellable: true
	})
}

/** Update Notification status
@docs Não existe
*/
export const updateNotificationStatus = (payload) => {
	return httpClient({
		method: 'PUT',
		url: `notification/preference/${payload.id}/allow/${payload.status}`
	})
}
